import type { MatchOffer } from 'types/MatchOffer';

/** Keep only prematch events whose league belongs to the given sport. */
export function filterPrematchSearchBySport(
  events: Map<number, MatchOffer[]>,
  sportId: number
): Map<number, MatchOffer[]> {
  const next = new Map<number, MatchOffer[]>();
  for (const [key, list] of events) {
    const filtered = list.filter((e) => e.league.sport === sportId);
    if (filtered.length > 0) {
      next.set(key, filtered);
    }
  }
  return next;
}
